<template>
    <div :class="['platformbar','reveal','active',
                    skinMode,           
                    platform_index >-1 ? 'index_selected':'',
                    platform_index >-1 && useSubBar ? 'expended':'',
                    platform_index >-1 ? 'mounted':'' ]">
        <!--removed: revealed === true ? 'active':'', -->

        <!-- todo wrapp here scroller -->
        <div class="barScroller" ref="barScroller1" :style="getPlatformsCountVar()">

          <!--
          <span @click="startOpenSeq()" v-if="revealed==false"
              style="color:#fff;curor:pointer;background-color:#000;padding:20px">
              Start
          </span>
          -->

          <ul :style="getPlatformsCountVar()" :class="['upperbar',getGridCss]">          
            <li v-for="(item, index) in sectionData.platforms" 
                  :class="['platformElement',item.color,platform_index == index ? 'selected' : '']"
                  :key="index" 
                  @click="changePlatform(index)">
              <div class="t1 tfx" :style="getStyleIndex(index)"><span>{{ms_localize(item.title)}}</span></div>
              <!-- <div class="t1 tfx" :style="getStyleIndex(index)"><span>{{item.title}}</span></div> -->
              <div class="t2 tfx" :style="getStyleIndex(index)"><span>{{getItemSize(item,false)}}</span></div>            
              <!-- masked button over state -->
              <div class="over start" :style="getStyleIndex(index)">
                  <div class="t1 t1b">{{ms_localize(item.title)}}</div> 
                  <!-- <div class="t1 t1b">{{item.title}}</div> -->
                  <div class="t2 t2b">{{getItemSize(item,false)}}</div>
              </div>
            </li>          
          </ul>
          <ul class="subbar" v-if="useSubBar" :style="'--count:'+sectionData.platforms.length">
            <li v-for="(item, index) in sectionData.platforms" :key="index">
              <div class="subsub" :style="'--count:'+item.items.length">
                  <span   
                        v-for="(itemx, subIndex) in item.items" 
                        @click="changeItem(index,subIndex,itemx.catalog_no)"
                        :class="[itemx.catalog_no == selected_product ? 'selected' :'']"
                        :key="subIndex">{{getItemSize(itemx,true)}}<i class="sub-mm">mm</i>
                  </span>
                  
              </div>
            </li>             
          </ul>
        </div>



    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines,isMobileScreen }  from "@/utils";

export default {
    name: "platformbar",
    props: 
    {
      affectOtherSections:Boolean,//this is to prevent updating the main store state value 
      isMenuOpen: Boolean,
      sectionIndex:Number,
      sectionContentData:null,
      skinMode:String
    },
    data()
    {
        return {
            useSubBar:false,
            sectionData:[],
            revealed:false,
            platform_index:-1,
            subitem_index:-1,
            selected_product:'',
            itemx:[]
        }
    },
    created()
    {
        if(this.sectionContentData!=null && this.sectionContentData.length>0)
        {
          this.sectionData = this.sectionContentData;
        }else{
          this.sectionData = this.minisite_data.SECTIONS[this.sectionIndex];
        }
        
        //useSubBar
        if(this.sectionData.useSubBar && this.sectionData.useSubBar=="true"){
          this.useSubBar=true;
        }

        var vm=this;
        setTimeout(() => {
            vm.changePlatform(0);
        }, 1000);
        /*        
        let sectionsList = this.siteData.SECTIONS;
        this.sectionData = sectionsList.filter(function(el){
          return el.section == vm.sectionName;
        });*/
    },
    watch: {
      '$store.state.xSelectedPlatform': function() {
        //alert("xP="+this.$store.state.xSelectedPlatform);
          var xIndex = this.$store.state.xSelectedPlatform;
          if(this.sectionData.section != 'cover_screw')
          {
            //do not affect by the store when in CoverScrew section
            this.changePlatform(xIndex);
          }else{
            //special case on CoverScrew
            if(xIndex==3){
              this.changePlatform(2);
            }else{
              this.changePlatform(xIndex);
            }
          }
      }
    },
    methods:
    {
        ...mapActions(["xSetPlatform"]),
        getItemSize(item,removeMM)
        {
          let _size = item.size;
          if(this.siteLang.toLowerCase()!="en"){
            _size = _size.replace('.',',');//european formats
          }
          if(removeMM)
          {
            _size = _size.replace("mm","");//<i>mm</i>")
          }
          return _size;
        },
        startOpenSeq()
        {
            this.revealed=!this.revealed;
        },
        changeItemIndex(subindex)
        {
            //called from parent compontent
            this.subitem_index = subindex;
        },
        changeItem(index,subindex,catalog_no)
        {
            this.platform_index = index;
            this.subitem_index = subindex;
            this.selected_product = catalog_no;
            this.$emit('item-change',catalog_no);
            this.$emit('platform-change',this.platform_index);

            //if(this.sectionData.section != 'cover_screw')
            //}
            this.scrollToIndex();// causes bugs 
        },
        scrollToIndex()
        {
            //on mobile, scroll the bar to the current location
            if(isMobileScreen())                        
            {
                setTimeout(() => {
                  //scroll on mobile version

                  let scrollerContainer = this.$refs.barScroller1;
                  
                  //let scrollToEl = this.$refs.barScroller1.getElementsByClassName("platformElement")[this.platform_index];                  
                  //const scrollX = scrollToEl.getBoundingClientRect().left;
                  
                  let scrollX=(this.platform_index*375)-50;///<<<<test

                  scrollerContainer.scrollTo({
                    top:0, left: scrollX, 
                    behavior: 'smooth',inline:'center',block:'nearest'});
                  
/*                   scrollToEl.scrollIntoView({ 
                    behavior:'smooth',
                    inline:'center',
                    block:'nearest'
                  });                  
 */                  
                }, 1000);
            }

        },
        doSomething()
        {
          //alert("doinggggg");
        },
        changePlatform(index)
        {          
            this.platform_index = index;  

            if(this.useSubBar)
            {
              //First selection case (user clicked first time on a platform)
              //Take the first product in the selected platform
              let firstProduct = this.sectionData.platforms[index].items[0];
              let catalog_no = firstProduct.catalog_no;
              this.selected_product = catalog_no;
            }

            //Tell the container to display the selected product
            this.$emit('item-change',this.selected_product);
            this.$emit('platform-change',this.platform_index);
            
            if(this.sectionData.section != 'cover_screw'){
              //do not affect the store when in CoverScrew section
              /////////////this.xSetPlatform(this.platform_index);//<<< updates the store
            }else{}

            this.scrollToIndex();
        },
        getPlatformsCountVar()
        {
          return "--itemscount:"+this.sectionData.platforms.length;
        },
        getStyleIndex(index){
            return "--index:"+index;
        }
    },
    computed:{
      ...mapState(["minisite_data","locale"]),
        getGridCss()
        {
          return 'items' + this.sectionData.platforms.length;
          //sectionData.platforms.length==4 ? 'items4' : 'items3'
        },
        siteLang()
        {
          return this.locale.ln;
        },
        xxxxsectionData()
        {
            let vm = this;
            let section = this.minisite_data.SECTIONS.filter(function(el){
              return el.section == "implant_range";vm.sectionName;
            });
            return section;//this.siteData.SECTIONS[2];
        }
    }
};
</script>






<style>
  .platformbar
  {
    text-align: left;
    width: 76vw;margin: auto;
    overflow: hidden;
    height: 92px; /* height for start mode */    
    transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    position: relative;  
    top:0px;  
  }
  .platformbar.expended
  {    
    height: 140px; /* height for expended mode using subbar mode */
  }
  .platformbar.mounted
  {    
    /*top:calc(50vh - 150px);*/
  }

  .platformbar ul.upperbar
  {
    list-style: none;
    width: 100%;
    height: 90px;
    display: grid;
    justify-items: center;
    gap: 10px;
    clear: both;
  }
  .platformbar ul.upperbar.items5
  {
    grid-template-columns: repeat(5, minmax(115px, 1fr));  
  }  
  .platformbar ul.upperbar.items4
  {
    grid-template-columns: repeat(4, minmax(115px, 1fr));  
  }  
  .platformbar ul.upperbar.items3
  {
    grid-template-columns: repeat(3, minmax(115px, 1fr));  
  }  
  .platformbar ul.upperbar li
  {
    cursor: pointer;
    margin: 2px;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    height: 90px;
    overflow: hidden;
    opacity: 0.4;
    transition: all ease 0.3s;
  }
  .platformbar.light ul.upperbar li
  {
    /* opacity: 0.6; */
    opacity: 1;
  }  
  .platformbar ul.upperbar li.selected
  {
    opacity: 1;
  }
  .platformbar ul li .t1{padding-top: 24px;font-size: 14px;color: #fff;
              font-weight: bold;overflow: hidden;}

  .platformbar ul li .t2{font-size: 17px;color: #fff;font-weight: bold;overflow: hidden;}
  .platformbar.light ul li .t1{color: #202020;}
  .platformbar.light ul li .t2{color: #202020;}

  .platformbar ul li .t1b{padding-left: 25px;font-weight:bold !important;}
  .platformbar ul li .t2b{padding-left: 25px;}
  .platformbar ul li .t1b{color: #fff !important;}
  .platformbar ul li .t2b{color: #fff !important;}

    .platformbar ul li .over
    {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        clip-path: inset(86px 0% 0% 0%);        
    }
    
    .platformbar.index_selected ul li.selected .over,
    .platformbar.active ul li.selected .over
    {
        clip-path: inset(0% 0% 0% 0%);
    }

    .platformbar ul li.Narrow .over{background-color: #fdd230;}
    .platformbar ul li.Standard .over{background-color: #9748a6;}
    .platformbar ul li.Wide .over{background-color: #63aa61;}
    /*
    .platformbar ul li:nth-child(1) .over{background-color: #fdd230;}
    .platformbar ul li:nth-child(2) .over{background-color: #9748a6;}
    .platformbar ul li:nth-child(3) .over{background-color: #9748a6;}
    .platformbar ul li:nth-child(4) .over{background-color: #63aa61;}
    */

  /* lowerbar */
  .platformbar ul.subbar
  {
    list-style: none;
    width: 100%;
    display: grid;justify-items: center;gap: 4px;
    grid-template-columns: repeat(var(--count), minmax(115px, 1fr));      
    clear: both;
  }

  .platformbar ul.subbar li
  {
    margin: 2px;box-sizing: border-box;width: 100%;
    height: 45px;color: #fff;
    border-bottom: solid 1px #ccc;
    overflow: hidden;
  }  
  .platformbar ul.subbar li span
  {
    position: relative;
    color: #202020;
    top: 10px;
    font-size: 12px;
    font-weight: 400;
    font-smooth: antialiased;
    -webkit-font-smoothing: antialiased;
    font-family: Arial, Helvetica, sans-serif;

  }  


    /* subsub */
  .platformbar .subsub 
  {
    width: 100%;
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(var(--count), minmax(20px, 1fr));
  }    
  .platformbar .subsub span
  {
    transition: all ease-in 0.2s;
    color:#fff;opacity: 0.5;
    padding-top: 5px;
  }    
  .sub-mm
  {
    font-style: normal;
    font-size: 10px !important;
    padding: 0px;
  }

  .platformbar .subsub span.selected
  {
    opacity: 1;
  }    


    /* ---------------- platforms animations prepare ---------------- */
    .platformbar .tfx.t1 span{
        top:22px;
        position: relative;
        transition: all 1.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition-delay: calc(0.1s + (0.1s * var(--index))) !important;
    }
    .platformbar .tfx.t2 span{
        top:22px;
        position: relative;
        transition: all 1.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition-delay: calc(0.15s + (0.1s * var(--index))) !important;
    }
    .platformbar ul li .over{clip-path: inset(86px 100% 0% 0%);}
    .platformbar ul li .over.start{
        transition: all 1.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        transition-delay: calc(0.1s + (0.2s * var(--index))) !important;
    }
    /* ---------------- platforms animatimg start ---------------- */    
    .platformbar.active .tfx.t1 span,
    .platformbar.index_selected .tfx.t1 span
    {top:0px;}
    .platformbar.active .tfx.t2 span,
    .platformbar.index_selected .tfx.t2 span
    {top:0px;}
    .platformbar.active ul li .over,
    .platformbar.index_selected ul li .over
    {clip-path: inset(86px 0% 0% 0%);}



  @media (hover: hover) 
  {
        .platformbar.light ul.upperbar li:hover,
        .platformbar ul li:hover{
            cursor: pointer !important;
            opacity: 1;
        }
        .platformbar .subsub span:hover
        {
            opacity: 1;
        }    
    }
  
  @media (max-width: 850px) { 
    .platformbar {
      width: 90vw;      
      margin: 0;
    }    
    .barScroller
    {
        overflow-x:scroll;
        overflow-y: hidden;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
        padding-left: 0px;
    }
    .barScroller::-webkit-scrollbar {
        display: none;
    }

    .platformbar.mounted {
        /*top: calc(100vh - 320px);*/
    }

    .platformbar ul.upperbar,
    .platformbar ul.subbar{
      width: calc(80vw * var(--itemscount));
    }    

    .platformbar ul li{
      opacity: 1;
    }
    .platformbar ul li span{
          opacity: 1;
    }    
  }  
</style>